import(/* webpackMode: "eager" */ "/home/jetrails/au.awbridal.com/html/src/app/(app)/template.jsx");
